/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UpdateTournamentPrizeBreakdownItem
 */
export interface UpdateTournamentPrizeBreakdownItem {
    /**
     * 
     * @type {number}
     * @memberof UpdateTournamentPrizeBreakdownItem
     */
    place?: number;
    /**
     * 
     * @type {number}
     * @memberof UpdateTournamentPrizeBreakdownItem
     */
    percentage?: number;
    /**
     * 
     * @type {number}
     * @memberof UpdateTournamentPrizeBreakdownItem
     */
    amount?: number;
}

/**
 * Check if a given object implements the UpdateTournamentPrizeBreakdownItem interface.
 */
export function instanceOfUpdateTournamentPrizeBreakdownItem(value: object): value is UpdateTournamentPrizeBreakdownItem {
    return true;
}

export function UpdateTournamentPrizeBreakdownItemFromJSON(json: any): UpdateTournamentPrizeBreakdownItem {
    return UpdateTournamentPrizeBreakdownItemFromJSONTyped(json, false);
}

export function UpdateTournamentPrizeBreakdownItemFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateTournamentPrizeBreakdownItem {
    if (json == null) {
        return json;
    }
    return {
        
        'place': json['place'] == null ? undefined : json['place'],
        'percentage': json['percentage'] == null ? undefined : json['percentage'],
        'amount': json['amount'] == null ? undefined : json['amount'],
    };
}

export function UpdateTournamentPrizeBreakdownItemToJSON(json: any): UpdateTournamentPrizeBreakdownItem {
    return UpdateTournamentPrizeBreakdownItemToJSONTyped(json, false);
}

export function UpdateTournamentPrizeBreakdownItemToJSONTyped(value?: UpdateTournamentPrizeBreakdownItem | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'place': value['place'],
        'percentage': value['percentage'],
        'amount': value['amount'],
    };
}

